export default __webpack_public_path__ + "static/media/gallery2.228c109d.jpg";